import { Autocomplete, Box, Tabs as TabsMui, styled } from '@mui/material';
import AppointmentSectionComponent from 'apps/wrapper/src/components/layout/slideout/patient-profile-widget/views/comm-preferences/shared/appointment-section/appointment-section';
import { Separator as SeparatorComponent } from '../../patient-profile-page.styles';
import AllCommunicationSectionComponent from 'apps/wrapper/src/components/layout/slideout/patient-profile-widget/views/comm-preferences/shared/sub-section/all-communication-section';
import CommunicationSubSectionComponent from 'apps/wrapper/src/components/layout/slideout/patient-profile-widget/views/comm-preferences/shared/sub-section/communication-sub-section';

export const Container = styled(Box)({
  margin: '20px 0'
});

export const TabContainer = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '189px 1fr',
  gap: '0'
});

export const TabTitle = styled(Box)({
  color: '#000000',
  width: '100%',
  padding: '0px 0px 0px 32px',
  fontWeight: 400,
  fontSize: 16,
  textTransform: 'initial',
  textAlign: 'left',
  span: {
    fontWeight: 400,
    fontSize: 12,
    display: 'block'
  }
});

export const Tabs = styled(TabsMui)({
  padding: '18px 0',
  marginTop: -17,
  '.MuiTabs-indicator': {
    display: 'none'
  },
  '.MuiTab-root': {
    marginBottom: 8,
    height: 54,
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    '&.Mui-selected': {
      backgroundColor: '#E8F2F6'
    }
  }
});

export const TabContent = styled(Box)({
  padding: '24px 24px',
  marginTop: -16,
  borderLeft: '1px solid #E9EAEE'
});

export const SaveContainer = styled(Box)({
  marginTop: 24,
  display: 'flex',
  justifyContent: 'flex-end',
  '.MuiButton-root': {
    width: 121
  }
});

export const Section = styled(Box)({
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: '24px 112px'
});

export const SectionTitle = styled(Box)({
  color: '#7D7D7D',
  marginBottom: 8,
  fontSize: 12,
  fontWeight: 400,
  textAlign: 'left'
});

export const SectionItem = styled(Box)({});

export const Dropdown = styled(Autocomplete)({
  width: '100%',
  marginTop: '8px'
});

export const Separator = styled(SeparatorComponent)({
  gridColumn: '1 / span 2',
  paddingTop: 4,
  paddingBottom: 4
});

export const AppointmentSection = styled(AppointmentSectionComponent)({
  padding: 0,
  borderBottom: 'none',
  '.appointment-header': {
    color: '#7D7D7D',
    fontSize: 12,
    fontWeight: 400,
    textAlign: 'left'
  }
});

export const SelectAllSection = styled(Box)({
  gridColumn: '1 / span 2',
  display: 'flex',
  justifyContent: 'flex-end'
})

export const AllCommunicationSection = styled(AllCommunicationSectionComponent)({
  padding: 0,
  '.all-communication-section': {
    backgroundColor: 'transparent',
    paddingRight: 0
  },
  '.all-communication-display-text': {
    fontSize: 14,
    fontWeight: 700,
    color: '#000'
  }
});

export const CommunicationSubSection = styled(CommunicationSubSectionComponent)({
  padding: 0,
})
